import { useEffect, useState } from 'react';
import { Constants } from '@/constants/constants';
import { Remote } from '@/api/remote';
import { ApiConstant } from '@/constants/api_constants';
import { Util } from '@/utils/utils';

const DEFAULT_EXPERT_ASK_TYPE = 'EXATYPE001';
const DEFAULT_FRNC_ID = 'STELLA';
interface FormData {
	companyName: string;
	userName: string;
	userNumber: string;
	userMail: string;
	userInquiry: string;
	inquiryAgree: boolean;
	expertAskType: string;
}
interface Content {
	currentPage: number;
	totalPage: number;
	list: [List];
}
interface List {
	askViewYn: string;
	expertAskTitle: string;
	expertAskCtnt: string;
	expertRplyCtnt: string;
	expertAskId: string;
	rplyYn: string;
}

const useConsultingForm = () => {
	const [content, setContent] = useState<Content>();
	const [formData, setFormData] = useState<FormData>({
		companyName: '',
		userName: '',
		userNumber: '',
		userMail: '',
		userInquiry: '',
		inquiryAgree: false,
		expertAskType: DEFAULT_EXPERT_ASK_TYPE
	});

	const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);

	// 입력값 변경을 처리하는 함수
	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const target = e.target as HTMLInputElement;
		const { name, value, type, checked } = target;

		setFormData(prev => ({
			...prev,
			[name]: type === 'checkbox' ? checked : value
		}));
		getCounsultingList(value, 1);
	};

	const getCounsultingList = async (expertAskType: string, page: number) => {
		try {
			const response = await Remote.Api.get(`${ApiConstant.mgmtExpertAsk.list}/${page.toString()}/10`, {
				expertAskType
			});
			if (response.code !== Constants.apiSuccess) {
				alert(response.message);
				return;
			}
			setContent(response.content);
		} catch (error) {
			console.error('Error submitting inquiry:', error);
		}
	};

	// 체크박스 동작을 추적하고 폼 제출 활성화 여부를 설정
	useEffect(() => {
		setIsSubmitEnabled(formData.inquiryAgree);
	}, [formData.inquiryAgree]);

	return {
		content,
		formData,
		handleInputChange,
		getCounsultingList
	};
};

export default useConsultingForm;
